import { BizError } from './client';

export const RETRY_BASE_MS = 1_000;
export const RETRY_MAX_MS = 30_000;

export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (error instanceof BizError) return false;
  const status = (error as { response?: { status?: number } })?.response?.status;
  if (status && status >= 400 && status < 500) return false;
  return failureCount < 2;
}

export function calcRetryDelay(attemptIndex: number): number {
  return Math.min(RETRY_BASE_MS * 2 ** attemptIndex + Math.random() * 1_000, RETRY_MAX_MS);
}
